import React, { useState, useEffect } from "react";
import moment from "moment";

function ChatTimer(data) {
  const [remaining, setRemaining] = useState(data.remainingTime);
  const [label, setLabel] = useState("");
  useEffect(() => {
    var timer;
    if (remaining > 0) {
      timer = setTimeout(() => {
        setRemaining(remaining - 1000);
        var duration = moment.duration(remaining);
        var days = duration.asDays();
        var hours = duration.asHours() % 24;
        var minutes = duration.asMinutes() % 60;
        var seconds = duration.asSeconds() % 60;

        let lbl =
          "Time left 0" +
          Math.floor(days) +
          "d : " +
          (hours < 9 ? "0" : "") +
          Math.floor(hours) +
          "h : " +
          (minutes < 9 ? "0" : "") +
          Math.floor(minutes) +
          "m : " +
          Math.floor(seconds) +
          "s";
        setLabel(lbl);
      }, 1000);
    } else {
      setLabel("Session Ended");
    }

    return () => {
      clearTimeout(timer);
    };
  }, [remaining]);

  return <div>{label}</div>;
}

export default ChatTimer;
